import React, { FC } from 'react'
import classNames from 'classnames'

import StylesModule from 'components/lv2/TitleText.module.scss'

export interface TitleTextProps {
  title: string
  text: string
  addClassName?: string
}

const TitleText: FC<TitleTextProps> = ({ title, text, addClassName }) => {
  addClassName = addClassName || ''
  return (
    <section
      className={classNames(StylesModule.titleText, StylesModule[addClassName])}
    >
      <h1 className={StylesModule.titleText__title}>{title}</h1>
      <div
        className={StylesModule.titleText__text}
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </section>
  )
}

export default TitleText
